import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('vkg_token');
    if (token) {
      api.get('/auth/me')
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('vkg_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const persistAuth = (payload) => {
    const token = payload?.data?.token || payload?.token;
    const nextUser = payload?.data?.user || payload?.user;
    if (token) localStorage.setItem('vkg_token', token);
    if (nextUser) setUser(nextUser);
    return payload;
  };

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    return persistAuth(res);
  };

  const register = async (data) => {
    const res = await api.post('/auth/register', data);
    return persistAuth(res);
  };

  const sendOtp = async (phone) => {
    return api.post('/auth/send-otp', { phone });
  };

  const verifyOtp = async (payload) => {
    const res = await api.post('/auth/verify-otp', payload);
    return persistAuth(res);
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('vkg_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, sendOtp, verifyOtp, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
